<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-close-button="false"
    :show-title="true"
    :width="'75%'"
    :height="300"
    :title="popupConfig.title"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-form gc-popup-schedule-note',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>

    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <template #switchTemplate>
      <div
        v-if="popupConfig.formMode !== 'create'"
        style="display: flex; align-items: center; gap: 8px"
      >
        <span>Active</span>
        <DxSwitch
          :value="model.Inactive === 'Y' ? false : true"
          @value-changed="
            (e) => {
              model.Inactive = e.value ? 'N' : 'Y';
            }
          "
          :read-only="popupConfig.formMode === 'review'"
        />
      </div>
    </template>

    <div class="css-v2 gc-popup-form">
      <GcForm
        :key="popupConfig.formKey"
        :formOptions="{
          gcLabelLocation: 'left',
        }"
        :formItems="getHeaderFormItems"
        :isNormal="true"
        :data-model="model"
        :formMode="popupConfig.formMode"
        :validationGroup="'gc-form-comp-schedule-note'"
        :formLocation="'normal'"
        :formHeight="195"
        ref="gc-form-comp-schedule-note"
        :valueChangeCallBack="valueChangeCallBack"
        :checkValid="isValid"
      />
    </div>

    <DxLoadPanel
      :position="{ of: '#container-wrapper' }"
      :visible.sync="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgba(0,0,0,0)"
    />

    <GcPopupAudit
      v-if="popupAuditVisible"
      :showPopup.sync="popupAuditVisible"
      :model.sync="auditModel"
    />
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { BillOfMaterialsService } from "../../_services/api/production/bill-of-materials.service";
import { mapGetters } from "vuex";
import { ProductionCalendarService } from "../../_services/api/production/production-calendar.service";
import DxSwitch from "devextreme-vue/switch";
import { combineDateTimeFromTwoDates } from "@/_helpers/collections/date-helper";
import { FeatureStorage } from "../../_services/storage";

export default {
  mixins: [DataGridMixin],
  components: {
    DxSwitch,
  },
  data() {
    return {
      IsFormLoaded: false,
      model: {
        RecordId: null,
        Inactive: "N",
        ProcessCode: null,
        StartDate: new Date(),
        StartTime: null,
        EndDate: new Date(),
        EndTime: null,
        Description: "",
      },
      isValid: false,
      loadingVisible: false,
      popupAuditVisible: false,
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {
        return {
          isPopupShow: false,
          formMode: "create",
          formKey: 1,
          secondaryTitle: "",
        };
      },
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    onHide: {
      type: Function,
      default: () => {},
    },
  },
  async created() {},
  methods: {
    /* Popup Events */
    onShown() {
      this.model = {
        RecordId: null,
        Inactive: "N",
        ProcessCode: null,
        StartDate: new Date(),
        StartTime: null,
        EndDate: new Date(),
        EndTime: null,
        Description: "",
      };

      if (this.dataModel) {
        this.model.ProcessCode =
          this.dataModel.ProductionScheduleNoteProcesses.map(
            (p) => p.ProcessCode
          );
        this.model.StartDate = this.dataModel.StartDateTime
          ? new Date(this.dataModel.StartDateTime)
          : new Date();
        this.model.StartTime = this.dataModel.StartDateTime
          ? new Date(this.dataModel.StartDateTime)
          : null;
        this.model.EndDate = this.dataModel.EndDateTime
          ? new Date(this.dataModel.EndDateTime)
          : new Date();
        this.model.EndTime = this.dataModel.EndDateTime
          ? new Date(this.dataModel.EndDateTime)
          : null;
        this.model.Description = this.dataModel.Description;
        this.model.RecordId = this.dataModel.RecordId;
        this.model.Inactive = this.dataModel.Inactive || "N";

        this.auditModel.createdBy = this.dataModel.CreatedBy;
        this.auditModel.dateCreated = this.dataModel.DateCreated;
        this.auditModel.changedBy = this.dataModel.ChangedBy;
        this.auditModel.dateChanged = this.dataModel.DateChanged;
      }
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      this.$nextTick(() => {
        let dataField = "ProcessCode";
        setTimeout(() => this.setFocusOnField(dataField), 700);
      });
    },

    /*
    Popup Hide Event
    */
    onPopupHide(repaint = true) {
      this.$emit("setIsVisible", false);

      this.onHide(repaint);
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    /**
     * Popup Initialized Event
     * @param e
     */
    onInitialized(e) {
      this.IsFormLoaded = true;
      e.component.registerKeyHandler("escape", (arg) => {
        arg.stopPropagation();

        this.$nextTick(() => {
          this.onCancelPopupHandler();
        });
      });
    },

    /**
     * Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.formMode === "review") {
        this.onPopupHide(false);
        return;
      }
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        if (confirm) {
          this.onPopupHide();
        }
      }
    },

    /**
     * Set Focus On Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      if (this.popupConfig.formMode !== "review") {
        if (
          this.$refs["gc-form-comp-schedule-note"] &&
          this.$refs["gc-form-comp-schedule-note"].$refs["gc-form-comp"]
        ) {
          this.$refs["gc-form-comp-schedule-note"].$refs[
            "gc-form-comp"
          ].instance
            .getEditor(dataField)
            .focus();
        }
      }
    },

    onSavePopupHandler() {
      this.isValid = true;
    },
    /**
     * Value Change Call Back
     * @param isValid Validation Status
     * @param brokenRules
     */
    async valueChangeCallBack(isValid, brokenRules) {
      var validations = "";

      if (!isValid) {
        brokenRules.forEach((element) => {
          validations += `<div style="width: 400px; padding-bottom: 5px;">${element.message}</div>`;
        });

        try {
          await this.$alert(validations, "Validation Error", {
            width: 400,
          });
        } catch (error) {
          // User might have pressed ESC, but we still need to reset
        }
      } else {
        // Process Save Here

        const finalResult = {
          ProcessCodes: this.model.ProcessCode.map((pc) => {
            return { ProcessCode: pc };
          }),
          StartDateTime: combineDateTimeFromTwoDates(
            this.model.StartDate,
            this.model.StartTime
          ),
          EndDateTime: combineDateTimeFromTwoDates(
            this.model.EndDate,
            this.model.EndTime
          ),
          Description: this.model.Description,
          Inactive: this.model.Inactive,
          RecordId: this.model.RecordId,
        };

        this.loadingVisible = true;
        try {
          const response = await ProductionCalendarService.saveScheduleNote(
            finalResult
          );

          if (response) this.loadingVisible = false;
          await this.$notify("Schedule Note saved successfully.", "success");

          this.onPopupHide();
        } catch (error) {
          this.loadingVisible = false;
          this.displayServerError(error);
        } finally {
          this.loadingVisible = false;
        }
      }

      // Always reset isValid after processing
      this.$nextTick(() => {
        this.isValid = false;
      });
    },

    onStartDateChange(e) {
      if (!e.event) return;
      this.model.EndDate = e.value;
    },

    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    onEditPopupHandler() {
      this.popupConfig.title = "Edit Schedule Note";
      this.popupConfig.formMode = "edit";
      this.popupConfig.formKey++;
      this.$nextTick(() => {
        let dataField = "ProcessCode";
        setTimeout(() => this.setFocusOnField(dataField), 700);
      });
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    /**
     * Get Header Form Items
     */
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "ProcessCode",
              label: { text: "Process", location: "left" },
              editorType: "dxTagBox",
              cssClass: "gc-tag-box",
              editorOptions: {
                dataSource: BillOfMaterialsService.dataSourceConfig(
                  "api/Process",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: "Code asc",
                  }
                ),
                valueExpr: "Code",
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Code}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description}
                            </span>
                          </div>`;
                },
                searchEnabled: true,
                showClearButton: true,
                placeholder: "Select Process",
                maxDisplayedTags: 3,
                showMultiTagOnly: false,
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                tabIndex: 1,
              },
              validationRules: [
                {
                  type: "required",
                  message: "Process is required",
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "DateIn",
                  dataField: "StartDate",
                  label: { text: "Start Date", location: "left" },
                  editorOptions: {
                    type: "date",
                    onValueChanged: (e) => {
                      this.onStartDateChange(e);
                    },
                    tabIndex: 2,
                    showClearButton: true,
                    format: "dd MMM yyyy",
                    dateSerializationFormat: "yyyy-MM-ddTHH:mm:ssx",
                  },
                  required: true,
                },
                {
                  screenField: "StartTime",
                  dataField: "StartTime",
                  label: { text: "Start Time", location: "left" },
                  editorType: "dxDateBox",
                  editorOptions: {
                    type: "time",
                    displayFormat: "hh:mm a",
                    showClearButton: true,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    tabIndex: 3,
                    dateSerializationFormat: "yyyy-MM-ddTHH:mm:ssx",
                  },
                  required: true,
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "DateIn",
                  dataField: "EndDate",
                  label: { text: "End Date", location: "left" },
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                    dateSerializationFormat: "yyyy-MM-ddTHH:mm:ssx",
                  },
                  required: true,
                },
                {
                  screenField: "StartTime",
                  dataField: "EndTime",
                  label: { text: "End Time", location: "left" },
                  editorType: "dxDateBox",
                  editorOptions: {
                    type: "time",
                    displayFormat: "hh:mm a",
                    showClearButton: true,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    min: this.model.StartTime,
                    tabIndex: 4,
                    dateSerializationFormat: "yyyy-MM-ddTHH:mm:ssx",
                  },
                  required: true,
                },
              ],
            },
            {
              dataField: "Description",
              label: { text: "Description", location: "left" },
              editorType: "dxTextArea",
              cssClass: "gc-text-area-large",
              editorOptions: {
                height: 80,
                maxLength: 1000,
                showClearButton: true,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                tabIndex: 5,
              },
            },
          ],
        },
      ];
    },

    /**
     * Get Toolbar Items
     */
    getToolbarItems() {
      return [
        {
          widget: "dxSwitch",
          location: "after",
          toolbar: "top",
          template: "switchTemplate",
          options: {
            value: this.model.Inactive === "Y" ? false : true,
            readOnly: this.popupConfig.formMode === "review",
          },
        },

        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "review" &&
            FeatureStorage.checkPermission("ProductionSchedule", "edit"),
          options: {
            icon: "edit",
            onClick: this.onEditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          // visible: this.popupConfig.formMode !== "review",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            // visible: this.popupConfig.formMode !== "review",
          },
        },
      ];
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-schedule-note {
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .gc-text-area-large {
    label.dx-field-item-label {
      padding-top: 4px;
    }
    textarea.dx-texteditor-input {
      padding-top: unset !important;
    }
  }

  .gc-popup-form {
    .gc-tag-box {
      .dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(
          .dx-editor-outlined
        )::after {
        border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
      }
    }
  }
}
</style>
